// Product Catalog Mock Data

export const productCatalog = {
  poloShirts: {
    title: "Polo T-Shirt Selection Catalogue",
    subtitle: "Premium Quality | 100% Cotton | Comfort Fit",
    colors: [
      { id: 1, name: "Black", hex: "#000000", image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/aphongcl_WhatsApp%20Image%202026-02-24%20at%205.09.47%20AM.jpeg" },
      { id: 2, name: "White", hex: "#FFFFFF", image: "" },
      { id: 3, name: "Red", hex: "#DC2626", image: "" },
      { id: 4, name: "Turkish Blue", hex: "#06B6D4", image: "" },
      { id: 5, name: "Royal Blue", hex: "#1E40AF", image: "" },
      { id: 6, name: "Orange", hex: "#EA580C", image: "" },
      { id: 7, name: "Navy Blue", hex: "#1E3A8A", image: "" },
      { id: 8, name: "Maroon", hex: "#881337", image: "" },
      { id: 9, name: "Lemon", hex: "#FDE047", image: "" },
      { id: 10, name: "Green", hex: "#15803D", image: "" },
      { id: 11, name: "Grey", hex: "#6B7280", image: "" },
      { id: 12, name: "Yellow", hex: "#FACC15", image: "" },
      { id: 13, name: "Charcoal", hex: "#374151", image: "" },
      { id: 14, name: "Beige", hex: "#D4B896", image: "" },
      { id: 15, name: "Pink", hex: "#F9A8D4", image: "" }
    ],
    features: [
      { icon: "Shirt", text: "180 GSM Fabric" },
      { icon: "Wind", text: "Breathable" },
      { icon: "Droplets", text: "Quick Dry" },
      { icon: "Heart", text: "Soft Feel" },
      { icon: "Shield", text: "Durable Stitching" }
    ],
    sizes: ["S", "M", "L", "XL", "XXL", "3XL"],
    idealFor: [
      { icon: "Building2", text: "Corporate" },
      { icon: "Users", text: "Staff Uniform" },
      { icon: "Calendar", text: "Events" },
      { icon: "Gift", text: "Promotional" },
      { icon: "ShoppingBag", text: "Daily Wear" }
    ]
  },
  
  chefCollection: {
    title: "Chef Coat Collection",
    subtitle: "Premium Kitchen Uniforms",
    items: [
      { id: 1, name: "White Chef Coat", color: "White", image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/k4izzqlf_WhatsApp%20Image%202026-02-24%20at%205.09.46%20AM%20%283%29.jpeg" },
      { id: 2, name: "Black Chef Coat", color: "Black", image: "" },
      { id: 3, name: "White with Black Piping", color: "White/Black", image: "" },
      { id: 4, name: "Black with White Piping", color: "Black/White", image: "" }
    ],
    products: [
      { name: "Chef Coats", image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/x1mjxgov_WhatsApp%20Image%202026-02-24%20at%205.09.46%20AM%20%282%29.jpeg" },
      { name: "Aprons", image: "" },
      { name: "Half Apron", image: "" },
      { name: "Chef Bandana", image: "" },
      { name: "Chef Pants", image: "" }
    ],
    features: [
      "Premium Fabric",
      "Breathable Material",
      "Durable Buttons",
      "Custom Embroidery Available",
      "Bulk Orders Welcome"
    ]
  },
  
  embroideryService: {
    title: "Professional Embroidery Service",
    image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/evi08kxl_WhatsApp%20Image%202026-02-24%20at%205.09.46%20AM%20%281%29.jpeg",
    features: [
      "High-Quality Stitching",
      "In-House Embroidery Machines",
      "Custom Logo Branding",
      "Fast Turnaround"
    ],
    tagline: "Trusted by Businesses Across Kuwait"
  },
  
  customization: {
    title: "Printing & Embroidery Services",
    subtitle: "Professional customization for all uniforms",
    image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/sb8l3gbl_WhatsApp%20Image%202026-02-24%20at%205.09.46%20AM.jpeg",
    services: [
      { name: "Computer Embroidery", icon: "Sparkles" },
      { name: "DTF Printing", icon: "Printer" },
      { name: "All Colors Available", icon: "Palette" }
    ],
    availableSizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    availableColors: ["White", "Black", "Navy Blue", "Royal Blue", "Red", "Green"]
  }
};
